// Function index:
//   numParam(s)       — coerce a query string param to a positive integer, else null.
//   setUrlParams(p)   — replace the URL search params (history.replaceState).

export function numParam(s: string | null): number | null {
  if (!s) return null;
  const n = Number(s);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function setUrlParams(p: Record<string, string>): void {
  const url = new URL(location.href);
  url.search = '';
  for (const [k, v] of Object.entries(p)) url.searchParams.set(k, v);
  history.replaceState({}, '', url);
}
